export default __webpack_public_path__ + "static/media/regulatory--go-straight--g3.478e2d96.png";